import { INotificationItem, enNotificationNames } from '@/interfaces/notification';

export const itemMapper: INotificationItem[] = [
  {
    key: enNotificationNames.newContent,
    title: 'Novo conteúdo',
    description: 'Receba todas as novidades de conteúdos referente ao seu curso.'
  },
  {
    key: enNotificationNames.newCourseTrack,
    title: 'Novo curso no pacote',
    description: 'Receba todas as novidades de cursos referente ao seu pacote.'
  },
  {
    key: enNotificationNames.commentResponse,
    title: 'Resposta de comentário',
    description: 'Receba todas as notificações referente aos seus comentários.'
  },
  {
    key: enNotificationNames.sendEmailToStudents,
    title: 'E-mail dos produtores',
    description: 'Receba e-mail de promoções ou comunicados dos produtores.',
    disablePush: true
  }
];
